<div *ngIf="!emailSent">
  <h1 class="harp-card-title">Forgot User ID or Password</h1>
  <p>
    Enter your email address to receive an email containing your user ID and
    instructions to reset your password.
  </p>
  <p>
    All fields marked with an asterisk (<span class="required">*</span>) are
    required.
  </p>

  <form
    [formGroup]="forgotForm"
    id="forgot-account-form"
    (ngSubmit)="onSendEmail()"
  >
    <harp-input [inputConfig]="emailInputConfig"></harp-input>
  </form>

  <!-- Send Email Button -->
  <button
    type="submit"
    class="btn btn-primary btn-lg"
    [disabled]="forgotForm.invalid"
    form="forgot-account-form"
  >
    Send Email
  </button>

  <!-- Cancel Button -->
  <button
    [routerLink]="['/login/account-recovery']"
    queryParamsHandling="merge"
    type="button"
    class="btn btn-link btn-lg"
  >
    Cancel
  </button>

  <!-- EUA Reset Password Link -->
  <p class="mt-4 mb-0">
    <strong>Note:</strong> EUA users should reset their password in
    <a href="https://eua.cms.gov/iam/im/pri/">EUA</a>.
  </p>
</div>

<!-- Email Successfully Sent Message -->
<div *ngIf="emailSent">
  <h1 class="harp-card-title">Success!</h1>
  <p>
    If we are able to correctly identify your account, you will receive an email
    shortly with instructions containing your user ID and instructions to reset
    your password. If after a sufficient amount of time you don’t receive an
    email, go to the
    <a routerLink="/login/contact">Contact Help Desk</a> page for Help Desk
    contact information
  </p>
  <a [routerLink]="['/login']">
    <strong class="icon ion-md-arrow-round-back"></strong> Back to Login</a
  >
</div>
